<template>
  <div class="admin">
    <span class="link text" v-on:click="showLogin" v-if="!loggedIn && !loggingin">login</span>
    <input type="password" v-on:keypress="checkenter" v-model="password" v-if="loggingin && !loggedIn" /><button v-if="loggingin && !loggedIn" class="myButton" v-on:click="login">log in</button>
    <span class="text" v-if="loggedIn">logged in <span v-on:click="$emit('logout')" class="link text">x</span></span>
  </div>
</template>
<script lang="ts">
  export default {
    name: 'Admin',
    components: {
    },
    props: {
      loggedIn: Boolean
    },
    data: function () {
      return {
        loggingin: false,
        password: ""
      }
    },
    mounted: function () {

    },
    methods: {
      showLogin: function () {
        this.loggingin = true;
      },
      login: function () {
        this.$emit('login', this.password);
        this.password = '';
        this.loggingin = false;
      },
      checkenter(e) {
        if (e.key === "Enter") {
          this.$emit('login', this.password);
          this.password = '';
          this.loggingin = false;
        }
      }
    }
  }
</script>
<style scoped>
  input {
    border-radius: 6px;
  }
  .admin{
    width:100%;
    text-align:center;
    font-size:small;
  }
  .link{
    cursor: url("./../assets/BarbieArmPointer.png"), auto;
    text-decoration: underline;
  }
  .text{
    color: #edb856;
  }
  .myButton {
	box-shadow:inset 0px 1px 0px 0px #97c4fe;
	background:linear-gradient(to bottom, #3d94f6 5%, #1e62d0 100%);
	background-color:#3d94f6;
	border-radius:7px;
	border:1px solid #337fed;
	display:inline-block;
	cursor:pointer;
	color:#ffffff;
	font-family:Arial;
	font-size:12px;
	font-weight:bold;
	padding:2px 24px;
	text-decoration:none;
	text-shadow:1px 1px 2px #1570cd;
}
.myButton:hover {
	background:linear-gradient(to bottom, #1e62d0 5%, #3d94f6 100%);
	background-color:#1e62d0;
}
.myButton:active {
	position:relative;
	top:1px;
}

</style>